namespace TabAurous.OMS {
    export namespace FormatMasterService {
        export const baseUrl = 'OMS/FormatMaster';

        export declare function Create(request: Serenity.SaveRequest<FormatMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<FormatMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<FormatMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<FormatMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetDesignFormat(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<FormatMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/FormatMaster/Create",
            Update = "OMS/FormatMaster/Update",
            Delete = "OMS/FormatMaster/Delete",
            Retrieve = "OMS/FormatMaster/Retrieve",
            List = "OMS/FormatMaster/List",
            GetDesignFormat = "OMS/FormatMaster/GetDesignFormat"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetDesignFormat'
        ].forEach(x => {
            (<any>FormatMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
